module.exports = __webpack_public_path__ + "static/media/hacktoberLogo.3a5eff2c.jpg";